import { createSelector } from '@reduxjs/toolkit';

import getDealers from './getDealers';

const getOfficesName = createSelector(getDealers, ({ dealers }) => {
  const result: {
    [K: string]: string;
  } = {};

  dealers?.forEach(dealer => {
    dealer.offices.forEach(office => {
      result[office.id] = office.name;
    });
  });

  return result;
});

export default getOfficesName;
